import styled from 'styled-components';

export const ConflictBanner = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.warning}14;
  border: 1px solid ${({ theme }) => theme.colors.warning}40;
  border-left: 4px solid ${({ theme }) => theme.colors.warning};
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
`;

export const ConflictIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.warning}22;
  color: ${({ theme }) => theme.colors.warning};
  font-size: 15px;
`;

export const ConflictContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ConflictTitle = styled.div`
  font-weight: 700;
  font-size: 0.92rem;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 2px;
`;

export const ConflictSubtitle = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 10px;
`;

export const ConflictList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ConflictChip = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.danger}30;
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 0.76rem;
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;

  strong {
    font-weight: 700;
  }

  b {
    color: ${({ theme }) => theme.colors.danger};
    font-weight: 600;
  }
`;
